module.exports = __webpack_public_path__ + "static/media/fixit-10.113e923a.svg";